/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types */

export type Serializable<T> = T & { toJSON: () => string };

export default <T>(input: T): T & { toJSON: () => string } =>
  ({
    ...input,
    toJSON: () => JSON.stringify(input),
  }) as Serializable<T>;
